import { gql } from '../../__generated__';
import { OrderLineItem, SingleDocOrderLineItem } from '../../interfaces.graphql';
import { OrderItem } from '../../orders/overview/Orders.graphql';

export const ORDER_LINES_FROM_CHANGES = gql(`
  query OrderLinesFromChanges($id: Int!) {
    orderLinesFromChanges(licenseId: $id) {
      ...OrderLineItem
    }
  }
`);

export const SINGLE_DOC_ORDER_LINES_FROM_CHANGES = gql(`
  query SingleDocOrderLinesFromChanges($id: Int!) {
    singleDocOrderLineFromChanges(licenseId: $id) {
      ...SingleDocOrderLineItem
    }
  }
`);

export const CREATE_ORDER = gql(`
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      ...OrderItem
    }
  }
`);

// export const SINGLE_DOC_CREATE_INVOICE = gql(`
// mutation SingleDocCreateInvoice($input: SingleDocCreateInvoiceInput!) {
//     singleDocCreateInvoice(input: $input) {
//         ...Boolean
//     }
// }
// `);

export const SINGLE_DOC_CREATE_INVOICE = gql(`
  mutation SingleDocCreateInvoice($input: SingleDocCreateInvoiceInput!) {
    singleDocCreateInvoice(input: $input)
  }
`);

export const ANNUL_INVOICE = gql(`
  mutation AnnulInvoice($input: AnnulInvoiceInput!) {
    annulInvoice(input: $input)
  }
`);
